var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo__info infolink",attrs:{"href":"#"},on:{"click":_vm.clickEmail}},[_c('i',{staticClass:"fa fa-envelope-o",attrs:{"aria-hidden":"true"}}),_vm._v(" info @ mmkkyweb.com\n")])}
var staticRenderFns = []

export { render, staticRenderFns }